<div class="row" class="row border Page-Header">
    <div class="col-12 p-0">
      <h6 class="HeadContent">Study Unit Report</h6>
    </div>
  </div>

  <div class="row">
    <div class="col-12" >
        <div class="row">
            <div class="col-10">
                <div class="row">
                    <div class="col-12">
                        <form [formGroup]="StudyMaterialReportform">
                            <div class="row pt-2">
                                <div class="col-4">
                                    <select class="form-control form-control-sm" formControlName="SubjectID"
                                    (change)="SelectSubject($event)">
                                    <option selected value="" hidden>Select Subject</option>
                                    <option class="border-bottom" *ngFor="let s of subject;let i=index" [value]="s.ID"> {{s.Name}}</option>
                                  </select>
                                          
                                </div>
                                <div class="col-4">
                                    <select class="form-control form-control-sm" formControlName="MajorTopicID"
                                    >
                                    <option selected value="" hidden>Select Major Topic</option>
                                    <option class="border-bottom" *ngFor="let MT of MajorTopic;let i=index" [value]="MT.ID">{{MT.Name}}</option>
                                    </select>     
                            </div>
                            <div class="col-4">
                                <div class="d-flex">
                                    <div class="px-0">
                                      <button type="button"  class="btn btn-sm bl-btn" [disabled]="!StudyMaterialReportform.value.SubjectID" (click)="Fetchreports()">Run</button>
                                    </div>
                                  </div>
                               
                        </div>

                            </div>
                        </form>
                    </div>

                </div>

            </div>
            <div class="col-2">
                <div class="row">
                    <div class="col-12">

                    </div>

                </div>
            </div>
            <!-- <div class="col-2">
                <div class="row">
                    <div class="col-12">

                    </div>

                </div>
            </div> -->

        </div>
        <div class="row pt-2">
            <div class="col-12">
                <table id="table" class="table  table-sm table-bordered border-secondary table-hover table-responsive">
                    <thead>
                      <tr class="table-secondary table-bordered border-secondary middle">
                        <th class="col-md-2">Study Unit</th>
                        <th class="col-md-2">Subject</th>
                        <th class="col-md-2">Major Topic</th>
                        <th class="col-md-2">Concept</th>
                        <th class="col-md-2">SCL1</th>
                        <th>SCL2</th>
                        <th>SCL3</th>
                        <th>SCL4</th>
                        <th>SCL5</th>
                        <th>SCL6</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="middle2" *ngFor="let s of getreport;let i=index">
                        <td >{{s.Study_Unit_Name}}</td>
                        <td>{{s.Subject_Name}}</td>
                        <td>{{s.Major_Topic_Name}}</td>
                        <td >{{s.Concept_Name}}</td>
                        <td>{{s.SCL1_Name}}</td>
                        <td >{{s.SCL2_Name}}</td>
                        <td >{{s.SCL3_Name}}</td>
                        <td >{{s.SCL4_Name}}</td>
                        <td >{{s.SCL5_Name}}</td>
                        <td >{{s.SCL6_Name}}</td>
                      </tr>
                    </tbody>
                  </table>
            </div>

        </div>
        
        
    </div>
  </div>
      
  
